import moment from 'moment';
import React, { useEffect, useState } from 'react'
import Api from '../../../../Api';
import Timer from '../../../Elements/Timer';
import './ClaimCountdown.scss';

const ClaimCountdown = () => {
    const [nextClaimPeriod, setNextClaimPeriod] = useState(null);
    const isBetween48Hours = nextClaimPeriod?.startTime && moment.utc().isBetween(moment.utc(nextClaimPeriod?.startTime).add('-2', 'days'), moment.utc(nextClaimPeriod?.startTime));
    // check if claim is open
    // const claimIsOpen = moment.utc().isBetween(moment.utc(nextClaimPeriod?.startTime), moment.utc(nextClaimPeriod?.claimEndTime))

    const fetchPeriodData = () => {
        Api.NFT_GET_NEXT_PERIOD()
            .then(response => setNextClaimPeriod(response.data.nextClaimPeriod))
            .catch(() => setNextClaimPeriod({}));
    }   
    
    const onTimeOver = () => {
        fetchPeriodData();
    }

    useEffect(() => {
        fetchPeriodData();
    }, []);

    return (
        <div className="claim-countdown-component">
            {nextClaimPeriod === null ? null : isBetween48Hours && <div className="claim-countdown-component__timer"> 
                <h2>Claim will be available within:</h2>
                <span>
                    <Timer type="custom" useFormat claimTime={nextClaimPeriod?.startTime} onTimeOver={onTimeOver} />
                </span>
            </div>}
        </div>
    )
}

export default ClaimCountdown;
